import React, {useMemo} from "react";
import Layout from "../layout/Layout";
import { ImportSelectFilePage } from "../import/ImportSelectFilePage";
import { ImportVerifyPage } from "../import/ImportVerifyPage";
import { ImportVerifyResultsPage } from "../import/ImportVerifyResultsPage";
import { ImportDevicesSelectFilePage } from "./ImportDevicesSelectFilePage";
import { useDeviceImportContext } from "./ImportDevicesContextProvider";
import { ImportDevicesVerifyPage } from "./importDevicesVerifyPage";
import { ImportDevicesVerifyResultsPage } from "./importDevicesVerifyResultsPage";

export const ImportDevicesPage: React.FC = () => {

    const {
        currentStage,
    } = useDeviceImportContext()


    const content = useMemo(() => {
        switch (currentStage){
            case "select_file": return <ImportDevicesSelectFilePage/>
            case "verify": return <ImportDevicesVerifyPage/>
            case "verify_results": return <ImportDevicesVerifyResultsPage/>
        }

        return null;

    }, [currentStage])



    return (
        <Layout active="import-devices">

                {content}
        </Layout>
)
}